import { withMetrics } from './MetricsContext';
import ApplicationMetrics from './application-metrics';

export default ApplicationMetrics;
export { withMetrics };
